<template>
    <b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; height: 100%; margin: 0; position: relative;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 100%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:1;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ProjectStatusProgressGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        this.snapshotData = this.dashboardData.snapshot;
        if(this.snapshotData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                if(this.isFlexible) {
                    
                    this.series = [];
                    this.chartOptions.xaxis.categories = [];
                    this.reloadGraph();
                }
            }
        },
    },
    data() {
        return {
            thereIsNoData:false,
            loading:false,
            startDate: '',
            endDate: '',
            columnNames: [],
            snapshotData :[],
            series: [],
            chartOptions: {
                chart: {
                    height:'80%',
                    type: "area",
                    stacked: false,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#142459', '#19AADE' , '#1BD4D4', '#6DF0D2', '#553AC1'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        // borderRadius: 10,
                        dataLabels: {
                            total: {
                                enabled: this.isFlexible,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },
                },
                markers: {
                    size: this.isFlexible ? 3 : 0,
                    strokeWidth: 1,
                },
                dataLabels: {
                    enabled: false, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#333'], // 데이터 라벨의 색상을 지정합니다.
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -9, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#fff',
                        padding: 4,
                        borderRadius: 4,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 0.8,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                stroke: {
                    width: [2, 2, 2, 2, 2],
                    curve: 'smooth',
                },
                xaxis: {
                    categories: [],
                    show:this.isFlexible,
                    labels: {
                        show:this.isFlexible
                    },
                    axisTicks: {
                    tickPlacement: 'on', // 'on' 또는 'between' 중 선택
                    },
                },
                yaxis: [
                    {
                        labels: {
                            show:this.isFlexible
                        }
                    },
                    // {
                    //     seriesName: 'Total',
                    //     labels: {
                    //         show:this.isFlexible
                    //     }
                    // }
                ],
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid :{
                    show:false
                }
            },
            tableData: [],
            // statusInfo : {
            //     'TOTAL' : true, 
            //     'TO_DO' : true, 
            //     'IN_PROGRESS' : true, 
            //     'DONE' : true, 
            //     'CANCELLED' : false,
            //     'CONFIRMED' : false,
            //     'APPROVED' : false
            // }
            seriesNameArray:['To Do', 'In Progress', 'Done+', "Closed+", 'Total']
        }
    },
    methods: {
        getLabelDateArray() {

            // 신세계의 경우 스케줄러가 돌지 않으므로 하루 단위가아닌 임포트 날짜 단위로 그래프 생성
            let projectId = this.dashboardData.projectInfo.projectId;

            let eow = null;
            let interval = 7;

            let dateArray = [];

            this.snapshotData.forEach(data => {
                if(data.date != '') {
                    dateArray.push(data.date);
                }
            });
            let labelDateArray = [...new Set(dateArray)]; // 라벨데이터
            labelDateArray.sort((a, b) => new Date(a) - new Date(b));

            let from = labelDateArray[0];
            let to = labelDateArray[labelDateArray.length - 1];
            
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }
                
                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                    eow = null;
                    
                }

                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                    
                }

            }

            // 신세계 프로젝트는 스케줄러를 사용하여 snapshot을 저장하지 않으므로 실 데이터만을 사용하여 최초 labelDate 생성
            if(projectId == 'SSG' || projectId == 'SSG-PL' || projectId == 'SSG-PO') {
                interval = -1;
            }

            labelDateArray = generateLabelDateArray(from, to, labelDateArray, interval, eow);

            return labelDateArray;
        },

        countData(labelDateArray, dataArray) {
            
            const arraySize = labelDateArray.length;

            let countObj = {}
           
            this.seriesNameArray.forEach(item => {
                countObj[item] = new Array(arraySize).fill(0);
            })

            let interval = 1;
            interval = Number(interval);
            for(let index = 0; index < labelDateArray.length;) {
                let labelDate = labelDateArray[index];

                let startDate = new Date(labelDate);
                let endDate = new Date(startDate);

                endDate.setDate(endDate.getDate() + interval);
                dataArray.forEach(item=> {
                    let itemDate = new Date(item.date);

                    if(startDate <= itemDate && itemDate < endDate) {        
                        switch (item.status) {
                            case 'TO_DO':
                                countObj['To Do'][index] += item.count;
                                break;
                            case 'IN_PROGRESS':
                                countObj['In Progress'][index] += item.count;
                                break;
                            case 'DONE':
                            case 'CANCELLED':
                                countObj['Done+'][index] += item.count;
                                break;
                            default :
                                countObj['Closed+'][index] += item.count;
                        }
                        countObj['Total'][index] += item.count;
                    }
                })

                countObj['Total'][index] = countObj['To Do'][index] + countObj['In Progress'][index] + countObj['Done+'][index] + countObj['Closed+'][index]

                if(countObj['Total'][index] == 0) {
                    // countObj 배열들의 해당 인덱스 제거
                    this.seriesNameArray.forEach(item => {
                        countObj[item].splice(index, 1);
                    })

                    labelDateArray.splice(index, 1);
                    continue;
                }
                index++;
            }
            console.log(countObj);
            // this.chartOptions.yaxis.max = Math.max(...countObj['Total']);
            return countObj;
        },

        visualizeGraph() {

            let dataArray = this.snapshotData;

            let labelDateArray = this.getLabelDateArray();

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                let from = labelDateArray[0];
                let to = labelDateArray[labelDateArray.length - 1];

                dataArray = dataArray.filter(item => {
                    let fromDateValid = true;
                    let toDateValid = true;

                    if(from != '' ) {
                        fromDateValid = item.date >= from;
                    }

                    if(to != '') {
                        toDateValid = item.date <= to;
                    }

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory) &&
                        fromDateValid &&
                        toDateValid
                    );
                });
            }

            let countObj = this.countData(labelDateArray, dataArray);

            
            // for(let index = 0; index < labelDateArray.length; ) {
            //     if(countObj['Total'][index] == 0) {
            //         // countObj 배열들의 해당 인덱스 제거
            //         this.seriesNameArray.forEach(item => {
            //             countObj[item].splice(index, 1);
            //         })

            //         labelDateArray.splice(index, 1);
            //         continue;
            //     }

            //     index++;
            // }
            // console.log(countObj);
            
            Object.keys(countObj).forEach(item =>{

                // 23-09-26 stacked bar => line 차트타입 변경
                // let type = 'bar';
                // let stacked = true;

                // if(item == 'Total' || item == 'Closed+') {
                //     type = 'line';
                //     stacked = false;
                // }
                if(item)
                this.series.push({
                    name : item,
                    type : 'area',
                    data : countObj[item],
                });
            });

            this.label = labelDateArray;
            this.setLabels();
        },

        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;


            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
                // this.$refs.apexchart.forceUpdate();
            }

            // if (this.$refs.apexchart) {
            //     this.$refs.apexchart.updateOptions({
            //         xaxis: {
            //             categories: this.label,
            //         },
            //     });
            // }
        },
        setTable() {
            this.tableData = this.data.table;

        },
    },
}
</script>
<style scoped>
.h-80 {
    padding-top: 10px;
    height: 80%;
}
.apexcharts-toolbar {
    top: 10px !important;
}
</style>